<template>
  <!-- eslint-disable -->
  <b-sidebar
    id="add-new-speciality"
    :visible="isAdd"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    no-close-on-backdrop
    @change="(val) => $emit('update:is-add', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">{{ isEdit ? 'Editar' : 'Agregar nuevo' }} local</h5>

        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="[hide(), resetForm()]" />
      </div>

      <!-- BODY -->
      <validation-observer #default="{ invalid }" ref="refFormObserver">
        <!-- Form -->
        <b-form class="p-2" @submit.prevent="onSubmit(items)">
          <!-- Titulo -->
          <validation-provider #default="{ errors }" name="establishmentType" rules="requeridoE">
            <b-form-group label="Tipo" label-for="tipo">
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="tipoLocal"
                label="text"
                :reduce="(tipoLocal) => tipoLocal.value"
                input-id="tipo"
                v-model="items.establishmentType"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
          <validation-provider #default="{ errors }" name="name" rules="requeridoE">
            <b-form-group label="Nombre" label-for="nombre">
              <b-form-input
                id="nombre"
                autofocus
                trim
                :class="errors.length > 0 ? 'is-invalid' : null"
                placeholder="Nombre"
                v-model="items.name"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
          <validation-provider #default="{ errors }" name="ruc" rules="requeridoE">
            <b-form-group label="Ruc" label-for="ruc">
              <b-form-input
                id="ruc"
                autofocus
                trim
                :class="errors.length > 0 ? 'is-invalid' : null"
                placeholder="Ruc"
                v-model="items.ruc"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
          <validation-provider #default="{ errors }" name="address" rules="requeridoE">
            <b-form-group label="Direccion" label-for="direccion">
              <b-form-input
                id="direccion"
                autofocus
                trim
                :class="errors.length > 0 ? 'is-invalid' : null"
                placeholder="Dirección"
                v-model="items.address"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
          <!-- Form Actions -->
          <div class="d-flex mt-2 justify-content-end">
            <b-button
              :disabled="invalid"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              <b-spinner v-if="isDisabled" small />
              <span v-if="isDisabled" class="px-1">guardando...</span>
              <span v-else>{{ isEdit ? 'Actualizar' : 'Agregar' }}</span>
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="[hide(), resetForm()]"
            >
              Cancel
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
/* eslint-disable*/
import Vue from 'vue'
import { BootstrapVue } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import StoresService from '@/services/StoresService'
import vSelect from 'vue-select'
Vue.use(BootstrapVue)
export default {
  directives: {
    Ripple
  },
  components: {
    // Form Validation
    ValidationProvider,
    ValidationObserver,
    vSelect
  },
  props: {
    isAdd: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      required,
      // speciality: {
      //   title: ''
      // },
      isEdit: false,
      isDisabled: false,
      tipoLocal: [
        {
          id: 1,
          text: 'Tienda',
          value: 'STORE'
        },
        {
          id: 2,
          text: 'Establecimiento',
          value: 'WAREHOUSE'
        }
      ],
      items: {
        id: null,
        establishmentType: '',
        name: '',
        address: '',
        ruc: '',
      },
      temp: {}
    }
  },
  methods: {
    getData(items) {
      if (Object.entries(items).length !== 0) {
        this.temp = items
        this.items = items
        this.isEdit = true
      } else {
        this.temp = {}
        this.items = {
          establishmentType: 'Tienda',
          name: '',
          address: '',
          ruc: '',
        }
        this.isEdit = false
      }
      console.log('temp EN ADD', this.temp)
    },
    resetForm() {
      this.$refs.refFormObserver.reset()
      this.isEdit = false
      this.items = {
        establishmentType: 'STORE',
        name: '',
        address: '',
        ruc: ''
      }
    },
    async onSubmit(data) {
      console.log('data', data)
      this.$refs.refFormObserver.validate().then(async (success) => {
        if (success) {
          this.isDisabled = true
          let resp = ''
          if (this.isEdit == false) {
            resp = await StoresService.saveStore(data, this.$store)
          } else {
            let datos = {
              name: data.name,
              address: data.address,
              establishmentType: data.establishmentType,
              ruc: data.ruc,
            }
            console.log('datos',datos)
            resp = await StoresService.updateStore(data.id, datos, this.$store)
          }
          if (resp) {
            this.$swal({
              title: 'Añadido',
              text: 'El local ha sido ' + (this.isEdit == true ? 'actualizado.' : 'registrado.'),
              icon: 'success',
              customClass: {
                confirmButton: 'btn btn-primary'
              },
              buttonsStyling: false
            })
            console.log('this.$parent.$parent', this.$parent.$parent)
            this.$parent.$parent.$parent.getData()
            this.$emit('update:is-add', false)
            this.resetForm()
          } else {
            this.$swal({
              title: 'Error!',
              text: ' Hubo un error al ' + (this.isEdit == true ? 'actualizar' : 'registrar') + ' el local',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-primary'
              },
              buttonsStyling: false
            })
          }
          this.isDisabled = false
        } else {
          console.log('no validado')
        }
      })
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
